import config from 'shared/config';
import { createTheme } from '@material-ui/core/styles';
import './styles.css';

// adjust theme colors using client customization settings or default to storis colors
const darkAccent = config.COLORS.DarkAccent !== '' ? config.COLORS.DarkAccent : '#001745'; // dark blue
const primary = config.COLORS.Primary !== '' ? config.COLORS.Primary : '#003c71'; // storis blue
const secondary = config.COLORS.Secondary !== '' ? config.COLORS.Secondary : '#ef5f37'; // salmon
const text = config.COLORS.Text !== '' ? config.COLORS.Text : '#000C24'; // black blue

// ------STORIS Theme------ //
const muiSTORISTheme = createTheme({
	palette: {
		primary: {
			main: primary,
		},
		secondary: {
			main: secondary,
		},
		text: {
			primary: text,
			secondary: darkAccent,
		},
	},
	typography: {
		fontFamily: ['"Open Sans"', 'sans-serif'].join(','),
	},
	overrides: {
		MuiSnackbarContent: {
			root: {
				backgroundColor: text,
			},
		},
	},
});

export default muiSTORISTheme;
